import * as z from 'zod';

export const paymentMethodFieldTypeSchema = z.enum(['text', 'select']);

export const paymentMethodFieldQuerySchema = z.object({
  id: z.number(),
  payment_method_id: z.number(),
  type: paymentMethodFieldTypeSchema,
  label: z.string(),
  options: z.string().nullable(),
  is_required: z.boolean().optional(),
});

export type PaymentMethodFieldQuerySchema = z.infer<typeof paymentMethodFieldQuerySchema>;

export const paymentMethodFieldFormRowSchema = z.object({
  id: z.number(),
  payment_method_id: z.number(),
  type: paymentMethodFieldTypeSchema,
  label: z.string(),
  options: z.string(),
  is_required: z.boolean(),
});

export type PaymentMethodFieldFormRowSchema = z.infer<typeof paymentMethodFieldFormRowSchema>;
